import { render, staticRenderFns } from "./SerUser.vue?vue&type=template&id=53604ae6&scoped=true&"
import script from "./SerUser.vue?vue&type=script&lang=js&"
export * from "./SerUser.vue?vue&type=script&lang=js&"
import style0 from "./SerUser.vue?vue&type=style&index=0&id=53604ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53604ae6",
  null
  
)

export default component.exports